import styled from 'styled-components';
import color from './configs/color';

const AppWrapper = styled.div`
  background-color: ${color.whiteCloud};
  min-height: 100vh;
  overflow: hidden;
  font-family: Montserrat;
  .ant-spin {
    display: flex;
    justify-content: center;
    margin-top: 60px;
  }

  .ant-btn,
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 4px;
  }

  .ant-input-affix-wrapper {
    padding: 16px 20px;
  }

  .font-title1 {
    font-size: 36px;
    font-weight: 400;
  }
  .font-title1_medium {
    font-size: 36px;
    font-weight: 600;
  }
  .font-title2 {
    font-size: 24px;
    font-weight: 400;
  }
  .font-title2_medium {
    font-size: 24px;
    font-weight: 600;
  }
  .font-title3 {
    font-size: 18px;
    font-weight: 400;
  }
  .font-title3_medium {
    font-size: 18px;
    font-weight: 600;
  }
  .font-subtitle {
    font-size: 16px;
    font-weight: 400;
  }
  .font-subtitle_medium {
    font-size: 16px;
    font-weight: 600;
  }
  .font-subtitle1_bold {
    font-weight: bold;
    font-size: 16px;
  }
  .font-paragraph {
    font-size: 14px;
    font-weight: 400;
  }
  .font-paragraph_medium {
    font-size: 14px;
    font-weight: 600;
  }
  .font-paragraph_bold {
    font-size: 14px;
    font-weight: 700;
  }
  .font-desc {
    font-size: 12px;
    font-weight: 400;
  }
  .font-desc_medium {
    font-size: 12px;
    font-weight: 600;
  }
  .tetxt-center {
    text-align: center;
  }

  .component_equipment_no {
    padding: 5px;
    margin-top: 5px;
    border: 1px solid black;
  }

  .pointer {
    cursor: pointer;
  }

  .red {
    color: ${color.redBase};
  }

  .blue {
    color: ${color.blueDark};
  }

  .green {
    color: ${color.greenBase};
  }
`;

export default AppWrapper;
